import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TEXT_FIELDS } from '../../customer-service.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';

@Component({
  selector: 'app-networkofbusinessconnection',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent],
  templateUrl: './networkofbusinessconnection.component.html',
  styleUrls: ['./networkofbusinessconnection.component.scss']
})

export class NetworkofbusinessconnectionComponent implements OnInit {

  fields : Array<Partial<TEXT_FIELDS>>;
  columns : Array<Partial<Pick<TEXT_FIELDS, "label" | "key" | "route" | "path">>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  payload = {
    limit: 10,
    searchContent : null,
    status : null,
    searchAfterKey : null,
    type: "LISTING"
  }
  businessData: any;
  constructor(private API: ApiService, private _activated_route: ActivatedRoute,
    private util : UtilService
  ) {

    this.fields = [
      {label : "Business Network Name" , key : 'b2bNetworkName' , disabled : false},
      {label : "Owner" , key : "owner" , disabled : true},
      {label : "Email" , key : "email" , disabled : true },
      {label : "Role" , key : "role"  , disabled : true},
      {label : "Members" , key : "membersCount" , disabled : true},
     ];

     this.columns = [
      {label : 'GSBID#' , key : 'platformBusinesId' , route : true , path : '/user-management/businessContacts/businessConnectEdit'},
      {label : 'Members' , key : 'businessName'},
      {label : 'Owner' , key : 'businessOwner'},
      {label : 'Email' , key : 'businessEmail'},
      {label : 'Title' , key : 'businessOwnerTitle'},
      {label : 'Business Type' , key : 'organizationType'},
     ];

     this.businessNetworkDetails = {
       networkName : "Prasnana",
       owner : "pp@gmail.com",
       members : 10
     }



     this._activated_route.parent.data.subscribe(res => {
      this.businessData = res.data;
     });


   }

  ngOnInit(): void {
    if (this.businessData.businessNetworkId) {
      this.getBusinessUserNetworkMembers();
    }
  }


  getBusinessUserNetworkMembers() {
    this.API.create('business/findB2BNetworkMembers', {
      businessNetworkId: this.businessData.businessNetworkId,
      businessId : this.businessData.id,
      ...this.payload
    }).subscribe(response => {
      if (response.code === AppSettings.SUCESS_CODE) {
        const businessNetworkMembers = response.data.networkMembers;
        const searchKey = response.data.searchAfterKey;

        if (businessNetworkMembers) {
          const current = businessNetworkMembers;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(businessNetworkMembers != null && (businessNetworkMembers.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }

        this.prevSearchAfterKey =  searchKey;
        const { userData , ...rest } = response.data.b2bNetwork;
        let data = {
          ...rest,
          owner : userData.firstName + " " + userData.lastName,
          email : userData.email,
          role : 'Super Admin'
        }
        this.businessNetworkDetails = data;
      }
    });
  }

  updateBusinessNetwork(event) {
    if(event.b2bNetworkName!="General Network"){
      this.API.create('business/editB2BNetwork', event).subscribe(res => {
        if (res && res.code === GigsumoConstants.SUCESSCODE) {
          Swal.fire({
            icon : "success",
            title : 'Business Network Updated!',
            text : 'Business network updated successfully',
            showConfirmButton: false,
            allowOutsideClick : false,
            timer: 2000,
          });
          this.businessNetworkDetails = event;
        }
        this.util.stopLoader();
      });
    }
  }


  updateBusinessNetworkMembers(members: any) {
    const userData = members.value;
    let data = {
      businessNetworkId: this.businessData.businessNetworkId,
      businessId : userData.businessId,
      status: userData.connectionStatus
    }

    if(members.checked){
      this.util.startLoader()
       this.updateMembersbulk(data);
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        allowOutsideClick : false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        title : "Inactive Business " + userData.businessName,
        text : `Are you sure you want to move ${userData.businessName} to inactive state?`
      }).then(res=>{

        this.util.startLoader();
        const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

        if(res.isConfirmed){
          this.util.startLoader();
          this.updateMembersbulk(data);
        }
        else{
          updatedData.forEach(res=>{
            if(res.b2bNetworkId === userData.b2bNetworkId){
              res.connectionStatus = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
          this.util.stopLoader();
        }



      });


    }

  }


  updateMembersbulk(data){
    this.API.create('business/updateB2BNetworkMember', data).subscribe(res => {
      if(res) {
        this.util.stopLoader()
      }
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Users Updated!',
          text : 'User updated successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false
          this.userDatas.next([]);
          this.getBusinessUserNetworkMembers();
        }, 1000);
      }
    });
  }


  onSearch(value , obj : NetworkofbusinessconnectionComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onFilter(data , obj : NetworkofbusinessconnectionComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onScroll(obj : NetworkofbusinessconnectionComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getBusinessUserNetworkMembers();
    }
  }


}
